import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { getQueryStringParams } from '../../utils/getQueryStringParams';

/**
 * If you don't need to listen on query changes, use `useQueryParams` hook instead.
 */
export const useQuery = <T extends string>() => {
  const { search } = useLocation();

  return useMemo(() => getQueryStringParams<T>(search), [search]);
};
